
import React from 'react';
import { UserIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Popover, PopoverTrigger } from '@/components/ui/popover';
import { useAuth } from '@/contexts/auth/useAuth';

interface AccountButtonProps {
  children: React.ReactNode;
}

const AccountButton = ({ children }: AccountButtonProps) => {
  const { isAuthenticated, user } = useAuth();

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button 
          variant="outline" 
          size="sm" 
          className="rounded-full bg-kbeauty-cream hover:bg-kbeauty-cream/80 flex items-center gap-2 px-3"
        >
          <UserIcon className="h-4 w-4" />
          <span className="hidden md:inline">
            {isAuthenticated && user?.name ? user.name.split(' ')[0] : 'Account'}
          </span>
        </Button>
      </PopoverTrigger>
      {children}
    </Popover>
  );
};

export default AccountButton;
